export default {
  label: {
    agentNo: 'AgentNo',
    amount: 'Update amount',
    beforeAmount: 'Balance before update',
    channelName: 'Channel name',
    channelType: 'Channel type',
    createTime: 'time',
    id: 'Primary key id',
    merchatNo: 'Tên merchant',
    merchatOrderNo: 'Transaction code',
    transactionType: ' transaction Type',
    updateAmount: 'Balance after update',
    withdrawBack: 'Return the settlement'
  },
  types: [
    {
      label: 'payin',
      value: 1
    },
    {
      label: 'settlement',
      value: 2
    },
    {
      label: 'Return the settlement',
      value: 3
    },
    {
      label: 'transfer balance',
      value: 4
    },
    {
      label: 'transfer wallet',
      value: 5
    },
    {
      label: 'Manual deduction',
      value: 6
    },
    {
      label: 'Manual recharge',
      value: 7
    },
    {
      label: 'Agency commission',
      value: 8
    },
  ]
};



// WEBPACK FOOTER //
// ./src/i18n/lang/en/walletRecord.js